export enum WarrenModules {
  Home = 'home',
  Overview = 'overview',
  Cash = 'cash',
  Wealth = 'wealth',
  Trade = 'trade'
}
